export { default } from './LifeWheelDucks'
export * from './LifeWheelDucks'
